export default function CurrentCheck() {
 const currentURL = window.location.pathname; //現在のURLを取得
 const currentDir = currentURL.substring(0, currentURL.lastIndexOf("/")) + "/"; //
 const links = document.querySelectorAll(".js-current-check a"); //js-current-checkクラスのaタグを取得

 links.forEach((link) => {
  const linkHref = link.getAttribute("href"); //リンクのhref属性を取得
  if (linkHref && linkHref.startsWith("/")) {
   const linkDir = linkHref.substring(0, linkHref.lastIndexOf("/") + 1); //リンクのディレクトリを取得
   //リンクのディレクトリと現在のURLが一致しているか確認
   if (linkDir === currentDir || currentURL.startsWith(linkDir)) {
    link.classList.add("is-current");
   }
  }
 });
}
